import React from 'react';
import {_GPY} from '../../../env.js'

class GuppyiBranding extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      transition : "transition-start" ,
      imageId: 1,
      ypos: 0,
      ypos2: 0,
      ud: false,
      img: "",
    };
  }

  onData (data,key) {
    var tmp = "";
    for (var i in data.data) {
      tmp += data.data[i];
    }
    this.setState({img:tmp ,ud:true});
  }

  onSetTimeout(){
  }

  onInit(overlayConfig){
      this.setState({transition: "slideSmallFromDown-leave"});
  }

  componentDidMount() {
      this.props.display.registDataListener("___brd___",this);

      this.active();
      const img = new Image();
      img.onload = () => { this.setState({ud:false}) };
      img.onerror = () => {
          this.props.display.state.connection.send("get::brd");
      };
      img.src = _GPY.resource("images/gpybrand.png");
      this.interval = setInterval(() => this.active(), (7*1000));
  }

  active() {
    this.setState({ypos: this.props.display.toYPos( (Math.floor(Math.random() * (95) ))), ypos2: this.props.display.toYPos( (Math.floor(Math.random() * (95) ))), } , () => {
          this.setState({ transition:"fadeSlowInOut-active"},()=>{
             // this.interval_leave = setInterval( () => {this.leave()}, (10*1000));
          });
      }
    );
  }

  leave() {
    this.setState({transition: "fadeSlowInOut-leave"});
    clearInterval(this.interval_leave);
    this.interval_leave = undefined;
  }

  render() {
    return (
      <div>
        <div style={{zIndex:"5001",position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%',display:"inline",opacity:"1.0"}}>
          <div style={{zIndex:"5001",position : "absolute",left :"0px", top : this.state.ypos+"px", width :"100%",display:"inline",opacity:"1.0"}}>
            <img alt="www.guppyi.com - free version - your sportsscoreboard" className="image-fluid" style={{zIndex:"5001",display:"inline",opacity:"1.0",maxWidth: this.props.display.props.width+"px", maxHeight: this.props.display.props.height+"px"}} src={this.state.ud ? this.state.img : _GPY.resource("images/gpybrand.png")} />
          </div>
        </div>

        <div style={{zIndex:"5002",position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%',display:"inline",opacity:"1.0"}}>
          <div style={{zIndex:"5002",position : "absolute",left :"0px", top : this.state.ypos2+"px", width :"100%",display:"inline",opacity:"1.0"}}>
            <img alt="www.guppyi.com - free version - your sportsscoreboard" className="image-fluid" style={{zIndex:"5001",display:"inline",opacity:"1.0",maxWidth: this.props.display.props.width+"px", maxHeight: this.props.display.props.height+"px"}} src={this.state.ud ? this.state.img : _GPY.resource("images/gpybrand.png")} />
          </div>
        </div>
      </div>
    );
  }
}
export default GuppyiBranding;
